function StreamSwitcher(el, videoJsPlayer) {
    this.el = el;
    this.videoJsPlayer = videoJsPlayer;
    this.isOnMainStream = true;
    this.mainBtnEl = this.el.querySelector('.jsTypeMain');
    this.altBtnEl = this.el.querySelector('.jsTypeAlt');

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsTypeMain')) this.activateMainStream();
        else if (e.target.classList.contains('jsTypeAlt')) this.activateAlternativeStream();
    });
}

StreamSwitcher.prototype.activateMainStream = function() {
    if (this.isOnMainStream) return;

    this.mainBtnEl.classList.add('active');
    this.altBtnEl.classList.remove('active');

    this.isOnMainStream = true;
    this.videoJsPlayer.src({ type: streamType, src: mainStreamUrl });
};

StreamSwitcher.prototype.activateAlternativeStream = function() {
    if (!this.isOnMainStream) return;

    this.mainBtnEl.classList.remove('active');
    this.altBtnEl.classList.add('active');

    this.isOnMainStream = false;
    this.videoJsPlayer.src({ type: streamType, src: altStreamUrl });
};